import {load} from "recaptcha-v3";
import {CAPTCHA} from "../App";

export async function getToken():Promise<string>{
    let recaptcha = await load(CAPTCHA);
    let token = await recaptcha.execute('login');
    return token;
}